import React from 'react';
import './minimal.css';

const FeatureList = ({ items = [] }) => {
  return (
    <section className="min-features section">
      <div className="gn-container">
        <div className="min-feature-grid">
          {items.map((it, idx) => (
            <div className="min-feature" key={idx}>
              {it.icon && <img className="min-feature-icon" src={it.icon} alt="" />}
              <div className="min-feature-title">{it.title}</div>
              {it.desc && <div className="min-feature-desc">{it.desc}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureList;


